import { HttpClient } from '@shared/adapters/HttpClient';
import {
    CreateReceptionRequest,
    CreateReceptionResponse,
    ReturnedReception,
    ReturnedReceptionFilters,
    ReturnedReceptionsApiResponse,
} from '../models';

export class ReusedApiAdapter {
    constructor(private httpClient: HttpClient) {}

    /**
     * Obtiene la lista paginada de recepciones de rehusados
     */
    async getReceptions(filters?: ReturnedReceptionFilters): Promise<ReturnedReceptionsApiResponse> {
        const params: Record<string, string> = {};

        if (filters) {
            if (filters.search) params.search = filters.search;
            if (filters.status !== undefined) params.status = String(filters.status);
            if (filters.from_date) params.from_date = filters.from_date;
            if (filters.to_date) params.to_date = filters.to_date;
            if (filters.page) params.page = String(filters.page);
            if (filters.per_page) params.per_page = String(filters.per_page);
            if (filters.order_by) params.order_by = filters.order_by;
            if (filters.order_direction) params.order_direction = filters.order_direction;
        }

        return await this.httpClient.get<ReturnedReceptionsApiResponse>(
            '/returned-receptions',
            params
        );
    }

    /**
     * Obtiene una recepción específica por ID
     */
    async getReception(id: number): Promise<{ data: ReturnedReception }> {
        return await this.httpClient.get<{ data: ReturnedReception }>(
            `/returned-receptions/${id}`
        );
    }

    /**
     * Crea una nueva recepción de rehusados
     */
    async createReception(data: CreateReceptionRequest): Promise<CreateReceptionResponse> {
        return await this.httpClient.post<CreateReceptionResponse>(
            '/returned-receptions',
            data
        );
    }

    /**
     * Elimina una recepción (solo si no tiene líneas)
     */
    async deleteReception(id: number): Promise<{ message: string }> {
        return await this.httpClient.delete<{ message: string }>(
            `/returned-receptions/${id}`
        );
    }
}

